module.exports = __webpack_public_path__ + "img/cal.8a87ca8a.jpg";